// Safari 3.0+ "[object HTMLElementConstructor]" 
const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
if(isSafari) {
  document.body.classList.add("safari");
}

const topbar = document.getElementById("topbar__js");
const topbarBackground = document.getElementById("topbarBackground__js");
const mainNav = document.getElementById("mainNav__js");
const mobileNavTrigger = document.getElementById("mobileNavTrigger__js");
const detailLinksLists = topbar.querySelectorAll(".detailLinks");
const topLevelImages = topbar.querySelectorAll(".topLevelImage");
const topLevelLink = topbar.querySelectorAll(".topLevelLink");
const searchTrigger = document.getElementById("searchTrigger__js");
const searchModal = document.getElementById("searchModal__js");
const searchClose = document.getElementById("searchClose__js");
const searchInput = document.getElementById("Search-In-Modal");
let isOpen = false;

mobileNavTrigger.addEventListener("click", (e) => {
  if (mobileNavTrigger.classList.contains("open")) {
    topbar.classList.remove("detailOpen");
    mobileNavTrigger.classList.remove("open");
    document.body.classList.remove("mobileNavOpen");
    topbarBackground.style.height = "auto";
    detailLinksLists.forEach((el) => {
      el.classList.remove("show");
    });
  } else {
    topbar.classList.add("detailOpen");
    mobileNavTrigger.classList.add("open");
    document.body.classList.add("mobileNavOpen");
    topbarBackground.style.height = "100vh";
  }
});

searchTrigger.addEventListener("click", (e) => {
  if (searchModal.classList.contains("show")) {
    searchModal.classList.remove("show");
  } else {
    searchModal.classList.add("show");
    searchInput.focus();
    topbar.classList.remove("detailOpen");
    detailLinksLists.forEach((el) => {
      el.classList.remove("show");
    });
  }
});

searchClose.addEventListener("click", () => {
  searchModal.classList.remove("show");
  searchTrigger.focus();
});

// Menu

// window.addEventListener("load", () => {
//   setTimeout(() => {
//     menu.style.opacity = "1";
//   }, 200);
// });

window.onscroll = () => {
  scrollFunction();
};

const mobileClass = () => {
  if (window.innerWidth < 1200) {
    document.body.classList.add("mobile");
  } else {
    document.body.classList.remove("mobile");
  }
};

window.onresize = () => {
  mobileClass();
};

mobileClass();

const scrollFunction = () => {
  if (
    document.body.scrollTop > 100 ||
    document.documentElement.scrollTop > 100
  ) {
    topbar.classList.add("small");
  } else {
    topbar.classList.remove("small");
  }
};

scrollFunction();

const detailButtons = topbar.querySelectorAll('div[role="button"]');

detailLinksLists.forEach((dll) => {
  const toplevelid = dll.dataset.topleveldetailid;
  const collectionLinks = dll.querySelectorAll("li");
  collectionLinks.forEach((colLnk) => {
    const img = colLnk.querySelector("img");
    colLnk.addEventListener("mouseenter", () => {
      if (img) {
        img.classList.add("show");
        if (topLevelImages) {
          topLevelImages.forEach((tli) => {
            tli.classList.remove("show");
          });
        }
      } else if (toplevelid) {
        const topLevelImage = document.getElementById(
          `topLevelImage-${toplevelid}`
        );
        if (topLevelImage) {
          if (topLevelImages) {
            topLevelImages.forEach((tli) => {
              tli.classList.remove("show");
            });
          }
          topLevelImage.classList.add("show");
        }
      }
    });
    colLnk.addEventListener("mouseleave", () => {
      if (img) {
        img.classList.remove("show");
      }
    });
  });
});

topLevelLink.forEach((link) => {
  link.addEventListener("mouseenter", () => {
    if (window.innerWidth < 1200) {
    } else {
      topbar.classList.remove("detailOpen");
      detailButtons.forEach((el) => {
        el.classList.remove("shown");
        const details = document.getElementById(
          `details-${el.dataset.detailid}`
        );
        details.classList.remove("show");
      });
      if (topLevelImages) {
        topLevelImages.forEach((tli) => {
          tli.classList.remove("show");
        });
      }
      topbar.style.height = "auto";
    }
  });
});

detailButtons.forEach((btn) => {
  btn.addEventListener("click", () => {
    if (window.innerWidth < 1200) {
      const details = document.getElementById(
        `mobiledetails-${btn.dataset.detailid}`
      );
      let shown = false;
      if (details.classList.contains("show")) {
        shown = true;
      }
      detailLinksLists.forEach((el) => {
        el.parentElement.classList.remove("show");
        el.classList.remove("show");
      });
      if (!shown) {
        details.classList.add("show");
        details.parentElement.classList.add("show");
      }
    }
  });
  btn.addEventListener("mouseenter", () => {
    if (window.innerWidth < 1200) {
    } else {
      detailButtons.forEach((el) => {
        el.classList.remove("shown");
      });
      btn.classList.add("shown");
      if (topLevelImages) {
        topLevelImages.forEach((tli) => {
          tli.classList.remove("show");
        });
      }
      const topLevelImage = document.getElementById(
        `topLevelImage-${btn.dataset.detailid}`
      );
      if (topLevelImage) {
        topLevelImage.classList.add("show");
      }
      detailLinksLists.forEach((el) => {
        el.classList.remove("show");
      });
      topbar.classList.add("detailOpen");
      const details = document.getElementById(
        `details-${btn.dataset.detailid}`
      );
      details.classList.add("show");
      window.topbarHeight = topbar.offsetHeight + details.offsetHeight;
      if (window.topbarHeight < 480) {
        window.topbarHeight = 480;
      }
      topbarBackground.style.height = `${window.topbarHeight}px`;
      const closeMenu = (e) => {
        if (e.clientY > window.topbarHeight) {
          topbar.classList.remove("detailOpen");
          const details = document.getElementById(
            `details-${btn.dataset.detailid}`
          );
          details.classList.remove("show");
          topbar.style.height = "auto";
          if (topLevelImages) {
            topLevelImages.forEach((tli) => {
              tli.classList.remove("show");
            });
          }
          detailButtons.forEach((el) => {
            el.classList.remove("shown");
          });
          window.removeEventListener("mousemove", closeMenu);
        }
      };
      window.removeEventListener("mousemove", closeMenu);
      window.addEventListener("mousemove", closeMenu);
    }
  });
});

// Product page

const btn = document.getElementById("showIngredients");
const bgBlur = document.querySelector(".bg-ingridients, .closeSidePanel");
const list = document.getElementById("ingredientList");

if (btn && bgBlur && list) {
  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    list.classList.toggle("open");
    isOpen = !isOpen;
  });

  document.addEventListener("click", (e) => {
    if(e.target != list){
    list.classList.remove("open");
    isOpen = false;
  }
  });
}

// Header video

var player = document.getElementById("header_player");
var mp4 = document.getElementById("header_video_src");
var image = document.getElementById("header_image");
const srcs = [
  "https://cdn.shopify.com/s/files/1/0553/0157/0753/files/Video_03_Anschnitt__Lanserhof.mp4?v=1651497412",
  "https://cdn.shopify.com/s/files/1/0553/0157/0753/files/Video_04_4_2_Anschnitt__Lanserhof.mp4?v=1651497413",
  "https://cdn.shopify.com/s/files/1/0553/0157/0753/files/Video_04_Anschnitt__Lanserhof.mp4?v=1651497413",
  "https://cdn.shopify.com/s/files/1/0553/0157/0753/files/Video_05__Lanserhof.mp4?v=1651497412",
  "https://cdn.shopify.com/s/files/1/0553/0157/0753/files/Video_06__Lanserhof.mp4?v=1651497412",
  "https://cdn.shopify.com/s/files/1/0553/0157/0753/files/Video_08__Lanserhof.mp4?v=1651497412",
  "https://cdn.shopify.com/s/files/1/0553/0157/0753/files/Video_09__Lanserhof.mp4?v=1651497413",
  "https://cdn.shopify.com/s/files/1/0553/0157/0753/files/Video_10__Lanserhof.mp4?v=1651497412",
];

if (player && mp4) {
  const src = srcs[Math.floor(Math.random() * srcs.length)];
  mp4.src = src;

  player.load();
  player.play();

  player.addEventListener("loadeddata", () => {
    player.parentElement.style.opacity = "1";
  });

  mp4.addEventListener("error", () => {
    image.style.opacity = "1";
  });
}

// Newsletter Header

document.querySelectorAll(".hm_newsletter .close").forEach((el) => {
  el.addEventListener("click", () => {
    el.parentElement.style.opacity = "0";
    el.parentElement.style.pointerEvents = "none";
  });
});

